/* Core & libraries */
import React from "react";
import { useTheme } from "react-jss";

/* Helpers, constants, custom methods, internal libraries */

/* Components */
import UCModal from "../../ucmodal";
import Footer from "./footer";

/* Styles */
import styles from "./styles";

const PrimaryModal = ({showModal, setShowModal, setSelectedRow, modalIcon, modalTitle, modalDescription, modalContent, saveButtonText, submitCallback, dataTestId, spinnerName }) => {
  const theme = useTheme();
  const classes = styles({ theme });

  const handleSaveModal = () => {
    submitCallback()
  }

  return (
    <UCModal
      className={ classes.modal }
      showModal={ showModal }
      setShowModal={ setShowModal }
      modalIcon={ modalIcon }
      modalTitle={ modalTitle }
      modalDescription={ modalDescription }
      modalContent={ modalContent }
      modalFooter={ <Footer setShowModal={ setShowModal } handleSaveModal={ handleSaveModal } saveButtonText={saveButtonText} spinnerName={spinnerName} /> }
      dataTestId={dataTestId}
      onExited={() => setSelectedRow(false)}
    />
  )
}

export default PrimaryModal;
